import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Button,
  Typography,
  Select,
  MenuItem,
  SvgIcon,
  Tabs,
  Tab,
  Menu,
  Skeleton,
  CircularProgress,
  styled,
  Tooltip,
  tooltipClasses,
  Chip,
} from "@mui/material";

import {
  DatePickerStyle,
  PrimaryTypography,
  StyledSecondaryBookingTypography,
  StyledSecondaryServiceTypography,
  TypoGraph,
  TypographyDefault,
} from "../../Theme";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { ReactComponent as DownArrow } from "../../Icons/DownArrow.svg";
import { ReactComponent as UpArrow } from "../../Icons/UpArrow.svg";
import "./Overview.css";
import ManagementGraph from "./ManagementGraph";
import { ReactComponent as DatePickerIcon } from "../../Icons/Datepicker.svg";

import FaultReportGraph from "./FaultReportGraph";
import ServiceRequestGraph from "./ServiceRequestGraph";
import FacilityBookingsGraph from "./FacilityBookingGraph";
import axiosInstance from "../../Redux/AxiosInstance";
import { useSelector } from "react-redux";

import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import CustomDateRangePicker1 from "../../CommonComponents/CustomDateRange1";
import moment from "moment";
import { DateRangePicker } from "@mui/x-date-pickers-pro";
import { toast } from "react-toastify";



const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "#262D33",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#262D33",
    fontSize: "12px",
    color: "#F3F4F6",
    fontWeight: 400,
    borderRadius: "8px 8px 5px 8px",
    padding: "12px",
  },
}));
const getGraphChip = (data) => {
  const commonStyles = {
    borderRadius: "6px",
    textTransform: "capitalize",
    fontSize: "14px",
    fontWeight: 500,
    height: "24px",
    padding: "2px 6px 2px 4px",
    display: "flex", // Ensure proper layout of label and icon
    alignItems: "center", // Align icon and label vertically
    ".MuiChip-icon": {
      marginRight: "6px",
      marginLeft: "0px",
      color: "inherit", // Inherit the color from parent styles
    },
    ".MuiChip-label": {
      padding: 0,
      color: "inherit", // Inherit color for label
    },
  };

  if (data?.includes("-")) {
    const newData = data?.replace("-", "");
    return (
      <Chip
        label={newData}
        icon={<DownArrow />}
        sx={{
          backgroundColor: "#FEF3F2",
          color: "#B42318",
          border: "1px solid #FECDCA",
          ...commonStyles,
        }}
      />
    );
  } else {
    return (
      <Chip
        label={data}
        icon={<UpArrow />}
        sx={{
          backgroundColor: "#ECFDF3",
          color: "#067647",
          border: "1px solid #ABEFC6",
          ...commonStyles,
        }}
      />
    );
  }
};

const OverviewGraphSection = ({
  countDeatils,
  percentageChange,
  tabValue,
  yearSorting,
  LanguageData,
  isLoading,
  yearArray,
  setYearSorting,
  handleTabChange,
}) => {


  const [analytics, setAnalytics] = useState(null);
const { userRole } = useSelector((state) => state.PropertyDetails)
const { userDetails } = useSelector((state) => state.Login);
const [selectedDate, setSelectedDate] = useState(dayjs());
const [selectedFilter, setSelectedFilter] = useState("Today")
const [openDateRangePicker, setopenDateRangePicker] = useState(false);
const [selectedMonth, setSelectedMonth] = useState(dayjs());
const [selectedYear, setSelectedYear] = useState(dayjs());
const [datetimerangedata, setdatetimerangedata] = useState([null, null]);
const [dateSubmit, setdateSubmit] = useState(false);

// console.log(selectedFilter)

const fetchAnalytics = async () => {
  try {
    const fromDate =
  datetimerangedata?.[0]
    ? dayjs(datetimerangedata[0]).format("YYYY-MM-DD")
    : null;

const toDate =
  datetimerangedata?.[1]
    ? dayjs(datetimerangedata[1]).format("YYYY-MM-DD")
    : null;

    const params = {
      filter_role: userRole,
      company_id: userDetails?.company_user_id || null,
      filterType: selectedFilter,
    };
      params.date = selectedDate.format("YYYY-MM-DD");
      params.month = selectedMonth.format("YYYY-MM");
      params.year = selectedYear.format("YYYY");

    if (
      selectedFilter === "Custom_Date_Range" &&
      fromDate &&
      toDate
    ) {
      params.from_date = fromDate;
      params.to_date = toDate;
    }

    const response = await axiosInstance.get(
      `${process.env.REACT_APP_API_URL}dashboard_summary`,
      { params }
    );

    setAnalytics(response?.data?.data);
  } catch (error) {
    // console.error("Error fetching analytics data:", error);
    // toast.error(error?.response?.data?.detail)
    if(error?.response?.status === 403 && error?.response?.data?.detail =="User not found" || error?.response?.data?.detail == "Access Denied"){
      localStorage.clear();
      window.location.href = "/login";
    }
  }
};


const isFirstRender = useRef(true);

useEffect(() => {
  if (isFirstRender.current) {
    isFirstRender.current = false;
    fetchAnalytics(); // run only once on mount
    return;
  }

  // For later dependency changes, call normally
  fetchAnalytics();

}, [
  selectedFilter,
  selectedDate,
  selectedMonth,
  selectedYear,
  datetimerangedata,
  dateSubmit
]);

//   useEffect(() => {
//   setSelectedDate(null);
//   setSelectedMonth(null);
//   setSelectedYear(null);
// }, [selectedFilter]);


  return (
    <>
    
    <div id="section-1">
       {openDateRangePicker && (
                  <CustomDateRangePicker1
                    openDateRangePicker={openDateRangePicker}
                    setopenDateRangePicker={setopenDateRangePicker}
                    datetimerangedata={datetimerangedata}
                    setdatetimerangedata={setdatetimerangedata}
                    setdateSubmit={setdateSubmit}
                  />
                )}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "50px",
        }}
      >
        {isLoading ? (
          <Skeleton width={200} height={50} />
        ) : (
          
          <Box sx={{display : 'flex', justifyContent : 'space-between', alignItems : 'center', width : '100%'}}>
          <Typography
            sx={{ color: "#111927", fontWeight: 600, fontSize: "20px" }}
          >
            {LanguageData?.home_this_month || "Analytics"}
          </Typography>
          <Box sx={{display : 'flex', justifyContent : 'space-between', gap : 2}}>
            <Box sx={{ cursor: "pointer" }}>
            <Select
              value={selectedFilter}
              style={{
                borderRadius: "8px",
                border: "1px solid #D2D6DB",
                backgroundColor: "#FFFFFF",
                padding: "8px 14px 8px 14px",
                color: "#800000",
                fontWeight: 600,
                fontSize: "14px",
                height: "47px",
                minWidth: "92px",
              }}
              IconComponent={KeyboardArrowDownIcon}
              onChange={(e) => setSelectedFilter(e.target.value)}
            >
              
                <MenuItem key={'Today'} value={'Today'}>
                  Today
                </MenuItem>
                <MenuItem key={'Yesterday'} value={'Yesterday'}>
                  Yesterday
                </MenuItem>
                <MenuItem key={'Last Week'} value={'Last_Week'}>
                  Last Week
                </MenuItem>
                <MenuItem key={'Last Month'} value={'Last_Month'}>
                  Last Month
                </MenuItem>
                <MenuItem key={'Last one Year'} value={'Last_one_Year'}>
                  Last one Year
                </MenuItem>
                <MenuItem key={'Select Date'} value={'Select_Date'}>
                  Select Date
                </MenuItem>
                <MenuItem key={'Select Month'} value={'Select_Month'}>
                  Select Month
                </MenuItem>
                <MenuItem key={'Select Year'} value={'Select_Year'}>
                  Select Year
                </MenuItem>
                <MenuItem key={'Custom Date Range'} value={'Custom_Date_Range'}>
                  Custom
                </MenuItem>
          
            </Select>
          </Box>
          {selectedFilter === "Select_Date" && (
<LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
      sx={{
                        ...DatePickerStyle,
      
                        "& .MuiInputBase-root": {
                          color: "#111927",
                        },
                      }}
      format="DD/MM/YYYY"
                      slots={{
                        openPickerIcon: () => <DatePickerIcon />,
                      }}
        value={selectedDate}
        onChange={(newValue) => setSelectedDate(newValue)}
        maxDate={dayjs()}   // ⛔ Block future dates
      />
    </LocalizationProvider>
          )}

          {selectedFilter === "Select_Month" && (
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <DatePicker
      sx={DatePickerStyle}
      views={["year", "month"]}
      format="MM/YYYY"
      slots={{
        openPickerIcon: () => <DatePickerIcon />,
      }}
      value={selectedMonth}
      onChange={(newValue) => setSelectedMonth(newValue)}
      maxDate={dayjs()} // ⛔ future months blocked
    />
  </LocalizationProvider>
)}

{selectedFilter === "Select_Year" && (
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <DatePicker
      sx={DatePickerStyle}
      views={["year"]}
      format="YYYY"
      slots={{
        openPickerIcon: () => <DatePickerIcon />,
      }}
      value={selectedYear}
      onChange={(newValue) => setSelectedYear(newValue)}
      maxDate={dayjs()} // ⛔ future years blocked
    />
  </LocalizationProvider>
)}
{selectedFilter === "Custom_Date_Range" && (
  <>
  <Box
                              onClick={() => {
                                setopenDateRangePicker(true);
                              }}
                              sx={{
                                minWidth: "237px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                border: "1px solid #D2D6DB",
                                borderRadius: "8px",
                                backgroundColor : "#fff",
                                px: 2,
                                ml: 2,
                                "&:hover": {
                                  cursor: "pointer",
                                  backgroundColor: "#F9FAFB",
                                },
                              }}
                            >
                              <DatePickerIcon style={{ marginRight: "10px" }} />
                              <StyledSecondaryBookingTypography>
                                {Boolean(datetimerangedata[0])
                                  ? moment(datetimerangedata[0]?.$d).format("MMM D YYYY")
                                  : "MMM DD YYY"}{" "}
                                -{" "}
                                {Boolean(datetimerangedata[1])
                                  ? moment(datetimerangedata[1]?.$d).format("MMM D YYYY")
                                  : "MMM DD YYY"}
                              </StyledSecondaryBookingTypography>
                            </Box>
                           
                            </>
)}
    </Box>
          </Box>

        )}

        {/* <Box
          sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}
        >
          {isLoading ? (
            <Skeleton width={200} height={50} />
          ) : (
            <>
              <StyledTooltip
                title="The up/down trend indicator illustrates the comparison of data between the current month and the prior month."
                arrow
                placement="top-start"
              >
                <InfoIcon style={{ marginRight: "10px", cursor: "pointer" }} />
              </StyledTooltip>

              <StyledSecondaryServiceTypography>
                {LanguageData?.home_this_month || "Updated as of"}{" "}
                {moment(new Date()).format("DD MMMM YYYY")}
              </StyledSecondaryServiceTypography>
            </>
          )}
        </Box> */}
      </Box>
      {isLoading ? (
        <Skeleton variant="rounded" width="100%" height={80} />
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            marginTop: "20px",
            width: "100%",
          }}
        >
         <Box
   sx={{
    borderRadius: "8px 0px 0px 0px",
    border: "0.5px solid #E5E7EB",
    padding: "20px",
    backgroundColor: "#FFFFFF",
    width: "33.3%",
    position: "relative" // ⬅ ADD THIS
  }}
>
  {/* Tooltip + Info Icon */}
  <Tooltip title="Total number of visitors recorded in the system, including invited and ad-hoc visitors." placement="top" arrow>
    <InfoOutlinedIcon
      sx={{
        position: "absolute",
        right: 10,
        top: 10,
        fontSize: 18,
        color: "#6B7280",
        cursor: "pointer",
        "&:hover": {
          color: "#800000",
        },
      }}
    />
  </Tooltip>

  <StyledSecondaryServiceTypography style={{ fontWeight: 500 }}>
    {"Total Visitors"}
  </StyledSecondaryServiceTypography>

  <Typography sx={{ fontSize: "20px", fontWeight: 600, color: "#111927" }}>
    {analytics?.total_visitor_count || "-"}
  </Typography>
</Box>

          <Box
            sx={{
              border: "0.5px solid #E5E7EB",
              padding: "20px",
              backgroundColor: "#FFFFFF",
              width: "33.3%",
              position:"relative"
            }}
          >
             <Tooltip title="Number of visitors invited in advance through the system." placement="top" arrow>
    <InfoOutlinedIcon
      sx={{
        position: "absolute",
        right: 10,
        top: 10,
        fontSize: 18,
        color: "#6B7280",
        cursor: "pointer",
        "&:hover": {
          color: "#800000",
        },
      }}
    />
  </Tooltip>
            <StyledSecondaryServiceTypography style={{ fontWeight: 500 }}>
              {LanguageData?.home_invited_visitors || "Total Invited Visitors"}
            </StyledSecondaryServiceTypography>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{ fontSize: "20px", fontWeight: 600, color: "#111927" }}
              >
                {analytics?.total_invited_count || "-"}
              </Typography>
              {/* <TypographyDefault>
                {getGraphChip(percentageChange?.inviteVisitorChange)}
              </TypographyDefault> */}
            </Box>
          </Box>
          <Box
            sx={{
              borderRadius: "0px 8px 0px 0px",
              border: "0.5px solid #E5E7EB",
              padding: "20px",
              backgroundColor: "#FFFFFF",
              width: "33.3%",
              position:"relative"
            }}
          >
            <Tooltip title="Number of visitors who self-registered via the kiosk and generated their own QR code." placement="top" arrow>
    <InfoOutlinedIcon
      sx={{
        position: "absolute",
        right: 10,
        top: 10,
        fontSize: 18,
        color: "#6B7280",
        cursor: "pointer",
        "&:hover": {
          color: "#800000",
        },
      }}
    />
  </Tooltip>
            <StyledSecondaryServiceTypography style={{ fontWeight: 500 }}>
              {LanguageData?.home_property_staff || "Total Ad-hoc Visitors"}
            </StyledSecondaryServiceTypography>
            <Typography
              sx={{ fontSize: "20px", fontWeight: 600, color: "#111927" }}
            >
               {analytics?.total_adoc_count || "-"}
            </Typography>
          </Box>
        </Box>
      )}
      {isLoading ? (
        <Skeleton variant="rounded" width="100%" height={80} />
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
          }}
        >
          <Box
            sx={{
              borderRadius: "0px 0px 0px 8px",
              border: "0.5px solid #E5E7EB",
              padding: "20px",
              backgroundColor: "#FFFFFF",
              width: "33.3%",
              position:"relative"
            }}
          >
             <Tooltip title="Total number of visitors currently within the building premises." placement="top" arrow>
      <InfoOutlinedIcon
      sx={{
        position: "absolute",
        right: 10,
        top: 10,
        fontSize: 18,
        color: "#6B7280",
        cursor: "pointer",
        "&:hover": {
          color: "#800000",
        },
      }}
    />
  </Tooltip>
            <StyledSecondaryServiceTypography style={{ fontWeight: 500 }}>
              {LanguageData?.home_falut_report || "In-Building Visitors"}
            </StyledSecondaryServiceTypography>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <Typography
                sx={{ fontSize: "20px", fontWeight: 600, color: "#111927" }}
              >
                 {analytics?.in_count || "-"}
              </Typography>
              {/* <TypographyDefault>
                {getGraphChip(percentageChange?.faultReportChange)}
              </TypographyDefault> */}
            </Box>
          </Box>
          <Box
            sx={{
              border: "0.5px solid #E5E7EB",
              padding: "20px",
              backgroundColor: "#FFFFFF",
              width: "33.3%",
              position:"relative"
            }}
          >
             <Tooltip title="Number of visitors presently inside the premises." placement="top" arrow>
    <InfoOutlinedIcon
      sx={{
        position: "absolute",
        right: 10,
        top: 10,
        fontSize: 18,
        color: "#6B7280",
        cursor: "pointer",
        "&:hover": {
          color: "#800000",
        },
      }}
    />
  </Tooltip>
            <StyledSecondaryServiceTypography style={{ fontWeight: 500 }}>
              {LanguageData?.home_service_request || "Current IN"}
            </StyledSecondaryServiceTypography>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{ fontSize: "20px", fontWeight: 600, color: "#111927" }}
              >
                 {analytics?.in_count || "-"}
              </Typography>
              {/* <TypographyDefault>
                {getGraphChip(percentageChange?.serviceRequestChange)}
              </TypographyDefault> */}
            </Box>
          </Box>
          <Box
            sx={{
              borderRadius: "0px 0px 8px 0px",
              border: "0.5px solid #E5E7EB",
              padding: "20px",
              backgroundColor: "#FFFFFF",
              width: "33.3%",
              position:"relative"
            }}
          >
             <Tooltip title="Number of visitors who have exited the premises." placement="top" arrow>
    <InfoOutlinedIcon
      sx={{
        position: "absolute",
        right: 10,
        top: 10,
        fontSize: 18,
        color: "#6B7280",
        cursor: "pointer",
        "&:hover": {
          color: "#800000",
        },
      }}
    />
  </Tooltip>
            <StyledSecondaryServiceTypography style={{ fontWeight: 500 }}>
              {LanguageData?.home_facility_book || "Current OUT"}
            </StyledSecondaryServiceTypography>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{ fontSize: "20px", fontWeight: 600, color: "#111927" }}
              >
                 {analytics?.out_count || "-"}
              </Typography>
              {/* <TypographyDefault>
                {getGraphChip(percentageChange?.facilitiesChange)}
              </TypographyDefault> */}
            </Box>
          </Box>
        </Box>
      )}

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          marginTop: "50px",
          alignItems: "center",
        }}
      >
        {isLoading ? (
          <Skeleton width={200} height={50} />
        ) : (
          <Typography
            sx={{ color: "#111927", fontWeight: 600, fontSize: "20px" }}
          >
            {LanguageData?.home_overview || "Overview"}
          </Typography>
        )}
        {isLoading ? (
          <Skeleton width={200} height={50} />
        ) : (
          <Box sx={{ cursor: "pointer" }}>
            <Select
              value={yearSorting}
              style={{
                borderRadius: "8px",
                border: "1px solid #D2D6DB",
                backgroundColor: "#FFFFFF",
                padding: "8px 14px 8px 14px",
                color: "#800000",
                fontWeight: 600,
                fontSize: "14px",
                height: "36px",
                minWidth: "92px",
              }}
              IconComponent={KeyboardArrowDownIcon}
              onChange={(e) => setYearSorting(e.target.value)}
            >
              {yearArray.map((data, index) => (
                <MenuItem key={index} value={data}>
                  {data}
                </MenuItem>
              ))}
            </Select>
          </Box>
        )}
      </Box>
      {isLoading ? (
        <Skeleton variant="rounded" width="100%" height={500} />
      ) : (
        <>
          <Box
            sx={{
              borderRadius: "8px 8px 0px 0px",
              borderBottom: "1px solid #E5E7EB",
              backgroundColor: "#FFFFFF",
              marginTop: "10px",
            }}
          >
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              style={{ justifyContent: "space-between" }}
            >
              <Tab
                label={ "Total Visitors"}
                sx={{ flexGrow: 1 }}
              />
              <Tab
                label={LanguageData?.home_tab_faul || "Invited Visitors"}
                sx={{ flexGrow: 1 }}
              />
              <Tab
                label={LanguageData?.home_tab_servic || "Ad-hoc Visitors"}
                sx={{ flexGrow: 1 }}
              />
              <Tab
                label={LanguageData?.home_tab_facilit || "In-Building Visitors"}
                sx={{ flexGrow: 1 }}
              />
              {/* <Tab
                label={LanguageData?.home_tab_parcel || "Parcel"}
                sx={{ flexGrow: 1 }}
              /> */}
            </Tabs>
          </Box>
          {tabValue === 0 && <ManagementGraph />}
          {tabValue === 1 && <FaultReportGraph />}
          {tabValue === 2 && <ServiceRequestGraph />}
          {tabValue === 3 && <FacilityBookingsGraph />}
          {/* {tabValue === 4 && <ParcelCollectionGraph />} */}
        </>
      )}
    </div>
    </>
  );
};

export default OverviewGraphSection;
